<template>
  <button
    @click="$emit('click')"
    :type="type"
    :class="['btn btn-container', buttonCategoryClass, buttonClass]"
    :style="buttonStyle"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    type: {
      type: "button" | "submit" | "reset",
      default: "button",
    },
    buttonStyle: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: "",
    },
    /**
     * Button color
     * Allowed: "primary" | "ghost"
     */
    color: {
      type: String,
      default: "primary",
    },
    /**
     * Button variant
     * Allowed: "filled" | "outlined"
     */
    variant: {
      type: String,
      default: "filled",
    },
  },
  computed: {
    buttonCategoryClass() {
      return `${this.variant}-${this.color}-btn`;
    },
  },
};
</script>

<style scoped>
.btn-container {
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

.btn-container:disabled {
  cursor: not-allowed;
}

.filled-primary-btn {
  background-color: #247fec;
  color: white;
  border: 1px solid #247fec;
}

.outlined-primary-btn {
  background-color: white;
  color: #247fec;
  border: 1px solid #247fec;
}

.filled-red-btn {
  background-color: #CF4646;
  color: white;
  border: 1px solid #CF4646;
}

.outlined-red-btn {
  background-color: white;
  color: #CF4646;
  border: 1px solid #CF4646;
}

.filled-ghost-btn {
  background-color: transparent;
  color: #374151;
  border: none;
}

.outlined-ghost-btn {
  background-color: transparent;
  color: #374151;
  border: 1px solid #cfd3d9;
}


</style>


// WEBPACK FOOTER //
// src/components/Button/Button.vue